export default "<h3>Gateway IP Settings</h3>\n<app-api-gateway-settings></app-api-gateway-settings>\n"